import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconV2CorrectOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32"><path d="M27.999 5.679 12.854 23.083l-7.57-6.993-1.357 1.469 9.083 8.391L28 8.723V5.68z" /></svg>
);
